import { noop } from 'lodash';
import { createContext, useContext, useState } from 'react';

interface DragLayerContextType {
  show: (newView: React.ReactElement) => void;
  clear: () => void;
}

const DragLayerContext = createContext<DragLayerContextType>({
  show: noop,
  clear: noop,
});

export const DragLayerProvider = ({ children }) => {
  const [view, show] = useState<React.ReactElement | undefined>(undefined);

  return (
    <DragLayerContext.Provider value={{ show, clear: () => show(undefined) }}>
      {view}
      {children}
    </DragLayerContext.Provider>
  );
};

export const useDragLayer = () => useContext(DragLayerContext);
